import type { FaqRepository } from '../repositories/faq_repository'

export class DeleteFaqUseCase {
  constructor(private readonly repository: FaqRepository) {}

  execute(id: string): Promise<void> {
    return this.repository.delete(id)
  }
}
